export const propertyValidationConfig = {
  Apartments: [
    { key: "areaDetails", label: "Flat Super Area " },
    { key: "selectedBedRooms", label: "Bedrooms" },
    { key: "selectedBathRooms", label: "Bathrooms" },
    { key: "selectedCarParking", label: "Car Parking" },
    { key: "selectedStatus", label: "Status" },
    { key: "flatOnFloor", label: "Flat On Floor" },
    { key: "totalFloors", label: "Total Floors" },
    { key: "mainDoorFacing", label: "Main Door Facing" },
    { key: "balconies", label: "Balconies" },
    { key: "furnishing", label: "Furnishing" },
    { key: "ratePerSqFt", label: "Rate Per SqFt" },
    { key: "propertyFlooring", label: "Flooring" },
    { key: "transactionType", label: "Transaction Type" },
    { key: "stampDutyAndRegistrationCharges", label: "Stamp Duty & Registration" },
    { key: "approvalAuthority", label: "Approval Authority" },
  ],

  Villas: [
    { key: "plotArea", label: "Plot Area" },
    { key: "plotDimensions", label: "Plot Dimensions" },
    { key: "plotFacing", label: "Plot Facing" },
  ],

  Plots: [
    { key: "ratePerSqFt", label: "Rate Per SqFt" },
    { key: "transactionType", label: "Transaction Type" },
    
  ],
};